import { toast } from "sonner";

/**
 * The single entry point for user-facing notifications. Nothing outside
 * this file should import `sonner` directly - centralising it here is what
 * lets every feature share one consistent look, timing, and (if the
 * underlying library ever changes again) a one-file migration.
 */
export const notify = {
  success: (message: string, durationMs = 4000) => toast.success(message, { duration: durationMs }),
  // The message doubles as the toast id, so the same error raised by several
  // requests at once (a session that just ended) shows once, not stacked.
  error: (message: string, durationMs = 6000) => toast.error(message, { duration: durationMs, id: message }),
  warning: (message: string, durationMs = 5000) => toast.warning(message, { duration: durationMs }),
  info: (message: string, durationMs = 4000) => toast.info(message, { duration: durationMs }),
};
